import { ReactNode } from "react"
import AppLayout from "@/layouts/AppLayout"
import AdminNavigation from "@/components/admin/AdminNavigation"
import DashboardTopbar from "@/components/DashboardTopbar"
import Button from "@/components/Button"
import { router, useForm, usePage } from "@inertiajs/react"
import { AdminUsersProps } from "@/types/types"
import EditUserForm from "@/components/admin/EditUserForm"

type Inputs = {
  q: string
}

const AdminUsersPage = () => {
  const { users, total_count, q } = usePage<AdminUsersProps>().props

  const { data, setData, get, processing } = useForm<Inputs>({
    q,
  })

  const findUser = (e: React.FormEvent) => {
    e.preventDefault()

    get("/admin/users", {
      async: true,
      preserveState: true,
      preserveScroll: true,
    })
  }

  const showClearButton = Boolean(q) || Boolean(data.q)

  return (
    <>
      <DashboardTopbar title="Admin" />
      <AdminNavigation />

      <div className="padding mx-auto w-full max-w-xl space-y-8 py-6">
        <form onSubmit={findUser}>
          <h2 className="text-lg font-semibold text-gray-900">User lookup</h2>
          <div className="mt-3 overflow-hidden rounded-2xl border border-gray-100 bg-white shadow">
            <div className="space-y-5 px-4 pt-5 pb-6 sm:px-6">
              <div>
                <label
                  htmlFor="q"
                  className="block pb-1.5 text-sm font-medium text-gray-700"
                >
                  Search by email, name or FIDE ID
                </label>
                <div>
                  <input
                    type="text"
                    id="q"
                    required
                    className="focus:ring-chessdrop-600 block w-full rounded-xl border-0 p-3 text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
                    value={data.q}
                    onChange={(e) => setData("q", e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="flex items-center justify-between gap-x-3 border-t border-gray-200 px-4 py-4 sm:px-6">
              {showClearButton ? (
                <Button
                  type="button"
                  style="secondary"
                  onClick={() =>
                    router.visit("/admin/users", {
                      preserveScroll: true,
                    })
                  }
                  disabled={processing}
                >
                  Clear
                </Button>
              ) : (
                <div />
              )}
              <Button type="submit" loading={processing}>
                Search
              </Button>
            </div>
          </div>
        </form>

        {Boolean(q) ? (
          <>
            {users.length > 0 ? (
              <div className="space-y-5">
                <h2 className="text-lg font-semibold text-gray-900">
                  {total_count > 25
                    ? `Showing ${users.length} of ${total_count} users`
                    : `${users.length} user${users.length > 1 ? "s" : ""} found`}
                </h2>
                {users.map((user) => (
                  <EditUserForm key={user.email} user={user} />
                ))}
              </div>
            ) : (
              <div className="text-lg font-semibold text-gray-900">
                No users found.
              </div>
            )}
          </>
        ) : null}
      </div>
    </>
  )
}

export default AdminUsersPage

AdminUsersPage.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>
